import {createActions} from 'client/framework';

export default createActions(null, ['TOGGLE_OPTION', 'SET_SELECTED_OPTIONS']);
